import { planBuilderIneligibleAddonsRemoved } from '../actions/PlanBuilderActions';
import { PLAN_BUILDER_PRODUCT_LEVEL_FOR_PRODUCT_LINE_UPDATED, PLAN_BUILDER_SKU_REMOVED } from '../actions/constants/ActionTypes';
import { planBuilderProductConfigurationsSelector } from '../selectors/PlanBuilderSelectors';
import { productConfigurationsWithIneligibleAddonsRemovedSelector } from '../selectors/ProductConfigsSelectors';

/**
 * The add-ons middleware is responsible for removing any add-ons that are
 * no longer applicable with the updated productConfigurations,
 * e.g. if a user selects an add-on only available for Pro+ products and then
 * removes all Pro+ products in their cart
 */
export const removeIneligibleAddOnsMiddleware = store => next => action => {
  if ([PLAN_BUILDER_PRODUCT_LEVEL_FOR_PRODUCT_LINE_UPDATED, PLAN_BUILDER_SKU_REMOVED].includes(action.type)) {
    // Commit the previous action's payload to state so we can access
    // the updated productConfigurations below
    next(action);
    const state = store.getState();
    const productConfigurations = planBuilderProductConfigurationsSelector(state);
    const removedAddOnsConfig = productConfigurationsWithIneligibleAddonsRemovedSelector(state, {
      productConfigurations
    });
    // Update productConfigurations without ineligible add-ons in the
    // next dispatch
    store.dispatch(planBuilderIneligibleAddonsRemoved({
      productConfigurations: removedAddOnsConfig
    }));
    return;
  }
  return next(action);
};